
/**
 *
 * @param {Object} Options list of options
 */
const activateSubmenus = function(
    {
      selector = '.has-submenu',
      showClass = 'd-block',
      focusSelector = 'li',
    } = {},
) {
  const submenuTriggers = document.querySelectorAll(selector);

  submenuTriggers.forEach((el) => {
    const hrefId = el.getAttribute('href');
    const targetElement = document.querySelector(hrefId);
    const parentListItem = el.closest(focusSelector);

    // setup the click event
    el.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();

      if (targetElement) {
        targetElement.classList.toggle(showClass);
      }
    });

    parentListItem.addEventListener('focusout', (e) => {
      const test = parentListItem.matches(':focus-within');

      if (test === false && targetElement) {
        targetElement.classList.remove(showClass);
      }
    });
  });
};

export default activateSubmenus;
